import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isUnavailableSizesPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { isLimitedEditionSelector } from '../../../redux/product/product.selectors';
import { UnavailableSizesPopup as Component } from './unavailable-sizes-popup';
const unavailableSizesSelector = createSelector(popupParamsSelector, ({
  unavailableSizes
}) => unavailableSizes);
const mapStateToProps = createStructuredSelector({
  open: isUnavailableSizesPopupShownSelector,
  unavailableSizes: unavailableSizesSelector,
  isLimitedEdition: isLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const UnavailableSizesPopup = connect(mapStateToProps, mapDispatchToProps)(Component);